import { useState } from "react"; 
import DoctorListings from '../components/Appointments/Doctors';
import BookAppointment from "../components/Appointments/BookAppointment";

const DoctorsPage = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedDoctor, setSelectedDoctor] = useState(null);

    const handleOpenModal = (doctor) => {
        setSelectedDoctor(doctor);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedDoctor(null);
    };

  const doctors = [
    {
      image: "/assets/doctors/dr1.png",
      name: 'Dr. Arjun Mehta',
      specialty: 'Consultant Psychiatrist & Behavioral Health Specialist',
      location: '4-121, Akshardham Setu, Hyderabad',
      experience: '5 Years',
      rating: '4.5/5',
      availability: 'Available Today',
      availableUntil: '(until 5:00 pm)',
      isAvailable: true,
      distance: '1.3 km',
      directionsLink: 'https://maps.google.com/?q=...',
      timeSlots: [
        "09:30AM",
        "10:30AM",
        "11:00AM",
        "11:30AM",
        "12:00PM",
        "12:30PM",
      ],
      onBook: function () {
        handleOpenModal(this);
      },
    },
    {
      image: "/assets/doctors/dr2.png",
      name: 'Dr. Ananya Rao',
      specialty: 'Senior Clinical Psychologist',
      location: 'Yashoda Hospital, Somajiguda, Hyderabad',
      experience: '7 Years',
      rating: '4.5/5',
      availability: 'Available Today',
      isAvailable: true,
      distance: '1.3 km',
      directionsLink: 'https://maps.google.com/?q=...',
       timeSlots: [
        "10:00AM",
        "10:30AM",
        "11:30AM",
        "12:00PM",
      ],
      onBook: function () {
        handleOpenModal(this);
      },
    }
  ];

//   const breadcrumb = [
//     { label: 'Home', link: '/' },
//     { label: 'Find Doctor', link: '/doctors' },
//     { label: 'Book Appointment', link: '/book-appointment' }
//   ];

  return (
    <>
    <DoctorListings
      doctors={doctors}
      pageTitle="Book an Appointment"
    />
    
    {selectedDoctor && (
        <BookAppointment
          item={selectedDoctor}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onConfirm={(appointment) => {
            console.log("Appointment booked:", appointment);
            // 🔥 Call API here if needed
          }}
        />
      )}
      </>
  );
};

export default DoctorsPage;

// import { useState } from "react";
// import DoctorListings from "../components/Appointments/Doctors";
// import BookAppointment from "../components/Appointments/BookAppointment";

// const DoctorsPage = () => {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedDoctor, setSelectedDoctor] = useState(null);

//   const handleOpenModal = (doctor) => {
//     setSelectedDoctor(doctor);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedDoctor(null);
//   };

//   const doctors = [
//     {
//       id: 1,
//       profilePicture: "/assets/doctors/dr1.png",
//       title: "Dr. Arjun Mehta",
//       degree: "MD",
//       specialization: "Consultant Psychiatrist & Behavioral Health Specialist",
//       hospitalName: "Akshardham Health Center",
//       pincode: "Hyderabad",
//       experience: "5 Years",
//       rating: "4.5/5",
//       availability: "Available Today",
//       availableUntil: "(until 5:00 pm)",
//       isAvailable: true,
//       distance: "1.3 km",
//       directionsLink: "https://maps.google.com/?q=...",
//       timeSlots: [
//         "09:30AM",
//         "10:30AM",
//         "11:00AM",
//         "11:30AM",
//         "12:00PM",
//         "12:30PM",
//       ],
//       onBook: function () {
//         handleOpenModal(this);
//       },
//     },
//     {
//       id: 2,
//       profilePicture: "/assets/doctors/dr2.png",
//       title: "Dr. Ananya Rao",
//       degree: "PsyD",
//       specialization: "Senior Clinical Psychologist",
//       hospitalName: "Yashoda Hospital",
//       pincode: "Somajiguda, Hyderabad",
//       experience: "7 Years",
//       rating: "4.5/5",
//       availability: "Available Today",
//       isAvailable: true,
//       distance: "1.3 km",
//       directionsLink: "https://maps.google.com/?q=...",
//       timeSlots: [
//         "10:00AM",
//         "10:30AM",
//         "11:30AM",
//         "12:00PM",
//       ],
//       onBook: function () {
//         handleOpenModal(this);
//       },
//     },
//   ];

//   return (
//     <>
//       <DoctorListings
//         doctors={doctors}
//         pageTitle="Book an Appointment"
//       />

//       {/* Appointment Modal */}
//       {selectedDoctor && (
//         <BookAppointment
//           item={selectedDoctor}
//           isOpen={isModalOpen}
//           onClose={handleCloseModal}
//           onConfirm={(appointment) => {
//             console.log("Appointment booked:", appointment);
//             // 🔥 Call API here if needed
//           }}
//         />
//       )}
//     </>
//   );
// };

// export default DoctorsPage;
